<script setup lang="ts">
import { TmlButton, TmlPopup, TmlRichText } from '@teemill/components';
import type { Terms } from '@teemill/platform';
import dayjs from 'dayjs';

defineProps<{
  terms: Terms;
}>();

const emit = defineEmits<{
  (event: 'agree'): void;
}>();
</script>

<template>
  <TmlPopup
    max-height="100vh"
    max-width="900px"
    :hide-close="true"
    :close-on-backdrop="false"
    :scrollable="false"
    class="h-[90vh]"
  >
    <div class="flex flex-col h-full mx-6 mt-2">
      <div>
        <h1 class="mt-6">{{ terms.title }}</h1>
      </div>

      <div class="flex-1 mt-8 overflow-y-auto">
        <!-- eslint-disable-next-line -->
        <TmlRichText v-html="terms.content" />
      </div>

      <div class="mt-6">
        <i>Last updated: {{ dayjs(terms.updatedAt).format('DD/MM/YYYY') }}</i>

        <div class="flex justify-around mt-2 pb-6">
          <TmlButton
            as="primary"
            type="submit"
            class="mt-3 mr-2 min-w-64 min-h-12"
            @click="emit('agree')"
          >
            Accept
          </TmlButton>
        </div>
      </div>
    </div>
  </TmlPopup>
</template>
